// src/pages/ArticlePage.js
// HomeIQa individual article view
import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import articles from '../data/articles';

export default function ArticlePage() {
  const { slug } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <div style={s.page}>
        <nav style={s.nav}>
          <Link to="/" style={s.logoLink}><span style={s.logo}>HomeIQa</span></Link>
          <Link to="/blog" style={s.backLink}>&larr; Back to Blog</Link>
        </nav>
        <div style={{ textAlign: 'center', padding: '80px 24px' }}>
          <h1 style={{ ...s.title, fontSize: 28 }}>Article Not Found</h1>
          <p style={{ color: '#555', marginTop: 12 }}>
            The article you're looking for doesn't exist.
          </p>
          <Link to="/blog" style={s.backBtn}>Browse All Articles</Link>
        </div>
      </div>
    );
  }

  // Related articles: pick up to 3 that aren't the current one
  const related = articles.filter((a) => a.slug !== slug).slice(0, 3);

  return (
    <div style={s.page}>
      {/* NAV */}
      <nav style={s.nav}>
        <Link to="/" style={s.logoLink}><span style={s.logo}>HomeIQa</span></Link>
        <div style={s.navRight}>
          <Link to="/blog" style={s.backLink}>&larr; Back to Blog</Link>
          <Link to="/start" style={s.navCta}>Get My Report</Link>
        </div>
      </nav>

      {/* ARTICLE */}
      <article style={s.article}>
        {/* Meta */}
        <div style={s.meta}>
          <span>{article.date}</span>
          <span style={s.metaDot}>&middot;</span>
          <span>{article.readTime}</span>
          <span style={s.metaDot}>&middot;</span>
          <span>{article.author}</span>
        </div>

        <h1 style={s.title}>{article.title}</h1>

        {/* Body */}
        <div style={s.body}>
          {article.body.map((block, i) => {
            if (block.type === 'h2') {
              return <h2 key={i} style={s.h2}>{block.text}</h2>;
            }
            if (block.type === 'cta') {
              return (
                <div key={i} style={s.ctaBox}>
                  <p style={s.ctaText}>{block.text}</p>
                  <Link to="/start" style={s.ctaButton}>
                    Get Your Report for $29
                  </Link>
                </div>
              );
            }
            return <p key={i} style={s.p}>{block.text}</p>;
          })}
        </div>
      </article>

      {/* BOTTOM CTA */}
      <section style={s.bottomCta}>
        <h2 style={s.bottomCtaTitle}>Ready to know your home's value?</h2>
        <p style={s.bottomCtaSub}>
          Get a 12-page AI-powered valuation report grounded in real property data.
        </p>
        <Link to="/start" style={s.bottomCtaBtn}>
          Get Your Report for $29
        </Link>
      </section>

      {/* RELATED ARTICLES */}
      {related.length > 0 && (
        <section style={s.relatedSection}>
          <h2 style={s.relatedTitle}>More from HomeIQa Insights</h2>
          <div style={s.relatedGrid}>
            {related.map((r) => (
              <Link key={r.slug} to={`/blog/${r.slug}`} style={s.relatedCard}>
                <div style={s.relatedThumb}>
                  <span style={s.relatedThumbIcon}>&#9751;</span>
                </div>
                <div style={s.relatedBody}>
                  <div style={s.relatedMeta}>{r.date} &middot; {r.readTime}</div>
                  <div style={s.relatedCardTitle}>{r.title}</div>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}

    </div>
  );
}

/* ---------- STYLES ---------- */
const s = {
  page: {
    minHeight: '100vh',
    background: '#FAF7F2',
    fontFamily: "'Inter', 'DM Sans', sans-serif",
    color: '#1a1a2e',
  },

  /* Nav */
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: 1100,
    margin: '0 auto',
    padding: '18px 24px',
  },
  logoLink: { textDecoration: 'none' },
  logo: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 22,
    fontWeight: 700,
    color: '#5B1A2A',
  },
  navRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  backLink: {
    fontSize: 14,
    color: '#5B1A2A',
    textDecoration: 'none',
    fontWeight: 500,
  },
  navCta: {
    fontSize: 13,
    fontWeight: 600,
    color: '#fff',
    background: '#D4A017',
    padding: '8px 18px',
    borderRadius: 6,
    textDecoration: 'none',
  },

  /* Article */
  article: {
    maxWidth: 720,
    margin: '0 auto',
    padding: '32px 24px 48px',
  },
  meta: {
    fontSize: 13,
    color: '#888',
    marginBottom: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flexWrap: 'wrap',
  },
  metaDot: { color: '#ccc' },
  title: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 36,
    fontWeight: 700,
    color: '#5B1A2A',
    lineHeight: 1.2,
    margin: '0 0 32px',
  },

  /* Body */
  body: {},
  h2: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 22,
    fontWeight: 700,
    color: '#5B1A2A',
    margin: '32px 0 12px',
    lineHeight: 1.3,
  },
  p: {
    fontSize: 16,
    lineHeight: 1.75,
    color: '#333',
    margin: '0 0 18px',
  },

  /* Inline CTA box */
  ctaBox: {
    background: 'linear-gradient(135deg, #5B1A2A 0%, #7A2E40 100%)',
    borderRadius: 12,
    padding: '28px 32px',
    margin: '32px 0',
    textAlign: 'center',
  },
  ctaText: {
    fontSize: 15,
    lineHeight: 1.6,
    color: 'rgba(250,247,242,0.9)',
    margin: '0 0 16px',
  },
  ctaButton: {
    display: 'inline-block',
    background: '#D4A017',
    color: '#fff',
    fontSize: 15,
    fontWeight: 700,
    padding: '12px 28px',
    borderRadius: 8,
    textDecoration: 'none',
    letterSpacing: '0.01em',
  },

  /* Bottom CTA */
  bottomCta: {
    maxWidth: 720,
    margin: '0 auto 48px',
    padding: '40px 32px',
    background: '#fff',
    borderRadius: 12,
    textAlign: 'center',
    boxShadow: '0 2px 16px rgba(91,26,42,0.06)',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  bottomCtaTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 26,
    fontWeight: 700,
    color: '#5B1A2A',
    margin: '0 0 8px',
  },
  bottomCtaSub: {
    fontSize: 15,
    color: '#555',
    lineHeight: 1.5,
    margin: '0 0 20px',
  },
  bottomCtaBtn: {
    display: 'inline-block',
    background: '#D4A017',
    color: '#fff',
    fontSize: 16,
    fontWeight: 700,
    padding: '14px 32px',
    borderRadius: 8,
    textDecoration: 'none',
  },

  /* Back button (404) */
  backBtn: {
    display: 'inline-block',
    marginTop: 20,
    background: '#D4A017',
    color: '#fff',
    fontSize: 14,
    fontWeight: 600,
    padding: '10px 24px',
    borderRadius: 6,
    textDecoration: 'none',
  },

  /* Related articles */
  relatedSection: {
    maxWidth: 1100,
    margin: '0 auto',
    padding: '0 24px 64px',
  },
  relatedTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 24,
    fontWeight: 700,
    color: '#5B1A2A',
    margin: '0 0 24px',
    textAlign: 'center',
  },
  relatedGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 320px), 1fr))',
    gap: 20,
  },
  relatedCard: {
    background: '#fff',
    borderRadius: 10,
    overflow: 'hidden',
    textDecoration: 'none',
    color: 'inherit',
    boxShadow: '0 2px 10px rgba(91,26,42,0.05)',
    transition: 'box-shadow 0.2s',
    display: 'flex',
    flexDirection: 'column',
  },
  relatedThumb: {
    height: 100,
    background: 'linear-gradient(135deg, #5B1A2A 0%, #8B3A4A 40%, #D4A017 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  relatedThumbIcon: {
    fontSize: 24,
    color: 'rgba(255,255,255,0.25)',
  },
  relatedBody: {
    padding: '14px 18px 18px',
  },
  relatedMeta: {
    fontSize: 11,
    color: '#999',
    marginBottom: 6,
  },
  relatedCardTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 15,
    fontWeight: 700,
    color: '#5B1A2A',
    lineHeight: 1.3,
  },
};
